import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-active-document-v2",
  "use": "icon-active-document-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-active-document-v2\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#C3790F\" d=\"M5 4h4.586c.265 0 .52.105.707.293L12 6h7a1 1 0 0 1 1 1v2H4V5a1 1 0 0 1 1-1z\" /><path fill=\"#F5AF20\" d=\"M3.247 11h17.506a1 1 0 0 1 .977 1.217l-1.556 7a1 1 0 0 1-.976.783H4.802a1 1 0 0 1-.976-.783l-1.556-7A1 1 0 0 1 3.247 11z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol